import { GADimension } from '@ps/web-core-enums';
import produce from 'immer';
import { isNumber } from 'lodash';

import type { InputFill } from '../events';
import { inputFill } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import type { InputData } from './types';

export const inputFilled = (
  context: TrackingContextValue,
  data: InputData,
  stringValue?: string
) => {
  if (!data.fieldName) return;
  if (typeof data.strInput === 'string' && !data.strInput.trim()) return;
  if (!['boolean', 'undefined'].includes(typeof data.boolInput)) return;
  const value = isNumber(data.numInput) ? data.numInput : undefined;

  GAEvent({ action: 'Input Filled', label: data.fieldName, value }, context, {
    [GADimension.InputValue]: data.strInput || data.boolInput
  });

  if (!data?.fieldErrors?.length) delete data.fieldErrors;

  if (stringValue) {
    data = produce(data, (draft) => {
      data.fieldErrors?.forEach(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (item, index) => (draft.fieldErrors![index] = item.replace(stringValue, '****'))
      );
    });
  }

  inputFill({ isAutoFilled: false, ...data } as InputFill, context);
};
